import styled from "styled-components"

const StyledContainer = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: ${(props) => props.theme.fontsHeading};
  }
  a,
  p,
  span,
  label,
  button,
  input,
  article,
  aside,
  div,
  blockquote,
  details,
  figcaption,
  figure,
  summary,
  option,
  optgroup,
  select,
  textarea,
  fieldset,
  legend {
    font-family: ${(props) => props.theme.fontsText};
  }
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  [class*="-title"] a {
    &::before {
      background-color: ${(props) => props.theme.b_color_gradients.b_light};
    }
  }

  [class*="-title"] {
    &::before {
      background-color: ${(props) => props.theme.b_color_gradients.b_light};
    }
  }

  .btn {
    color: ${(props) => props.theme.a_color_gradients.a_dark};
    &::before {
      background-color: ${(props) => props.theme.b_color_gradients.b_light};
    }
    &::after {
      background-color: ${(props) => props.theme.c_color_gradients.c_medium};
    }
  }
  blockquote {
    border-left: 3px solid ${(props) => props.theme.c_color_gradients.c_medium};
  }
  @media (max-width: 900px) {
    blockquote {
      border-top: 3px solid ${(props) => props.theme.c_color_gradients.c_medium};
      border-bottom: 3px solid
        ${(props) => props.theme.c_color_gradients.c_medium};
      border-left: none;
    }
  }
`

export default StyledContainer
